import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_ARTICLE } from "../article.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateArticleInput } from "../../../__generated__/globalTypes";
import {
  CreateArticleMutation,
  CreateArticleMutationVariables,
} from "../../../__generated__/CreateArticleMutation";

interface IProps {
  defaultValues: DeepPartial<CreateArticleInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateArticle = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateArticleInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateArticleMutation,
    CreateArticleMutationVariables
  >(CREATE_ARTICLE, {
    refetchQueries: ["ArticlesQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createArticle?.ok) {
        onCompleted(data.createArticle.id);
      } else {
        throw Error(data?.createArticle?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
